import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { TareaForm as TareaFormType } from '@/components/tareas/forms'
import type { VencimientoConCliente } from '@/types/vencimientos'

interface Props {
  form: TareaFormType
  clienteSeleccionado: string | null
  vencimientos: VencimientoConCliente[]
  loading: boolean
}

/** Campo "Vencimiento Fiscal" del formulario de tarea. Se habilita con un cliente elegido. */
export function VencimientoField({ form, clienteSeleccionado, vencimientos, loading }: Props) {
  return (
    <form.Field name="vencimiento_id">
      {(field) => (
        <div className="space-y-2">
          <Label>Vencimiento Fiscal</Label>
          <Select
            onValueChange={(value) => field.handleChange(value === '_none' ? null : value)}
            value={field.state.value ?? '_none'}
            disabled={!clienteSeleccionado || loading}
          >
            <SelectTrigger>
              <SelectValue
                placeholder={
                  !clienteSeleccionado
                    ? 'Primero seleccione cliente'
                    : 'Seleccionar vencimiento'
                }
              />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="_none">Sin vencimiento</SelectItem>
              {vencimientos.filter((v) => v.id != null).map((v) => (
                <SelectItem key={v.id!} value={v.id!}>
                  {v.tipo_impuesto} - {v.periodo}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </form.Field>
  )
}
